import { render, staticRenderFns } from "./BgFormInput.vue?vue&type=template&id=170b306e"
import script from "./BgFormInput.vue?vue&type=script&lang=js"
export * from "./BgFormInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports